import { createContext, type Dispatch, type PropsWithChildren, type SetStateAction, use, useEffect, useState } from 'react';
import { getLocalTimeZone } from '@internationalized/date';
import { noop } from '@interxfi/utilities/fn/no-op';

const TimeZoneContext = createContext<[string, Dispatch<SetStateAction<string>>]>([getLocalTimeZone(), noop]);

interface TimeZoneContextProviderProps {
  timeZone?: string;
}

export function TimeZoneProvider({ children, timeZone = getLocalTimeZone() }: PropsWithChildren<TimeZoneContextProviderProps>) {
  const value = useState(timeZone);
  const [_, setTimeZone] = value;

  useEffect(() => {
    if (timeZone) {
      setTimeZone(timeZone);
    }
  }, [timeZone]);

  return <TimeZoneContext.Provider value={value}>{children}</TimeZoneContext.Provider>;
}

export function usePreferredTimeZone() {
  const [timeZone] = use(TimeZoneContext) ?? [getLocalTimeZone(), noop];
  return timeZone;
}
